import React, { useState } from 'react';
import { Link} from "react-router-dom";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import { useTranslation, Trans } from 'react-i18next';

const SupportModal = (props) => {
  const {
    buttonLabel,
    className
  } = props;
  const { t } = useTranslation('common')
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  return (
    <div>
      <div className="text-dark" onClick={toggle}>
        <FontAwesomeIcon className="text-primary mr-2" icon="question-circle" /> {t('support')}
      </div>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>{t('supportTitle')}</ModalHeader>
        <ModalBody className="text-center">
          <Trans i18nKey="supportDescription" ns="common">
            Si tienes alguna duda acerca de Trato Starter puedes enviarnos un email a <a href="mailto:soporte@trato.io">soporte@trato.io</a>
          </Trans>
          
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" className="mx-auto" onClick={toggle}>{t('actions.close')}</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default SupportModal;